import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { notifyUser } from "../utils/notifyUser";

export default function ResetPasswordPage() {
    const [form, setForm] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });

    const [error, setError] = useState("");

    const [success] = useState("");

    const navigate = useNavigate();

    const location = useLocation();

    const token = new URLSearchParams(location.search).get("tempPassword");

    useEffect(() => {
        if(!token) {
            setError("Token not found in URL.");
        }
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if(form.new_password !== form.confirm_password) {
            notifyUser(null, "error", "Passwords don't match", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }

        try {
            // Send the token (tempPassword), current password, new password, and confirm password to the backend
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`,
                {
                    token,
                    current_password: form.current_password,
                    new_password: form.new_password,
                    confirm_password: form.confirm_password,
                },
            );

            notifyUser(null, "success", "Password updated successfully.", "toast", null, null, null, null, null, false, false, "top-center");
            setTimeout(() => navigate("/login"), 2000);
        } catch(err) {
            if(err.response && err.response.data && err.response.data.error) {
                notifyUser(null, "error", err.response.data.error, "toast", null, null, null, null, null, false, false, "top-center");
            } else {
                notifyUser(null, "error", "Error updating password. Please try again.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        }
    };

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
                <h2 className="mb-4 text-2xl font-bold text-center">
                    Reset Password
                </h2>
                {error && (
                    <p className="text-sm text-center text-red-500">{error}</p>
                )}
                {success && (
                    <p className="text-sm text-center text-green-500">
                        {success}
                    </p>
                )}

                <form onSubmit={handleResetPassword} className="space-y-4">
                    <div className="input-group">
                        <label htmlFor="current_password">
                            Current Password
                        </label>
                        <input
                            type="password"
                            name="current_password"
                            id="current_password"
                            placeholder="Enter your current password"
                            value={form.current_password}
                            onChange={handleChange}
                            className="w-full p-2 border rounded"
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="new_password">New Password</label>
                        <input
                            type="password"
                            name="new_password"
                            id="new_password"
                            placeholder="Enter your new password"
                            value={form.new_password}
                            onChange={handleChange}
                            className="w-full p-2 border rounded"
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="confirm_password">
                            Confirm New Password
                        </label>
                        <input
                            type="password"
                            name="confirm_password"
                            id="confirm_password"
                            placeholder="Re-enter your new password"
                            value={form.confirm_password}
                            onChange={handleChange}
                            className="w-full p-2 border rounded"
                            required
                        />
                    </div>

                    <div className="submit-button">
                        <button
                            type="submit"
                            className="w-full py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
